import PropTypes from 'prop-types';
var itemType = {
  element: PropTypes.node,
  id: PropTypes.string,
  label: PropTypes.string,
  url: PropTypes.string
};
var linkType = {
  element: PropTypes.node,
  id: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape(itemType).isRequired),
  label: PropTypes.string,
  url: PropTypes.string
};
var contentType = {
  leadingArea: PropTypes.node,
  links: PropTypes.arrayOf(PropTypes.shape(linkType).isRequired),
  linksCustomStyle: PropTypes.any,
  trailingArea: PropTypes.node
};
var propTypes = {
  appearance: PropTypes.oneOf(['minimal', 'minimalcentered', 'secondary', 'tiered', 'ultraminimal']),
  className: PropTypes.string,
  customStyle: PropTypes.any,
  id: PropTypes.string,
  mainContent: PropTypes.shape(contentType),
  secondaryContent: PropTypes.shape(contentType)
};
export default propTypes;